module.exports = __webpack_public_path__ + "img/shopping_cart_blank_img@2x.833ab306.png";